import { createMuiTheme, CssBaseline, ThemeProvider } from "@material-ui/core";

import React from "react";
import DialogProvider from "./components/Dialogs/DialogProvider";
import App from "./App";
import { IntlProvider } from "react-intl";
import messages from "./assets/locales/messages";
import { BrowserRouter } from "react-router-dom";

function AppWrapper(props) {
  let locale = "en";
  if (navigator.language.substr(0, 2) === "nl") {
    locale = "nl";
  }

  const prefersDarkMode = false; // useMediaQuery("(prefers-color-scheme: dark)");

  const darkModePalette = {
    type: "dark",
    background: {
      default: "#040404",
      paper: "#141414",
      tertiary: "#212121",
    },
  };

  const whiteModePalette = {
    background: {
      tertiary: "#EFEFEF",
    },
  };

  let themeObj = {
    palette: {
      type: prefersDarkMode ? "dark" : "light",
      primary: { main: "#3f51b5" },
      ...(prefersDarkMode ? darkModePalette : whiteModePalette),
    },
    typography: {
      // fontSize: 14,
      // fontFamily: "Poppins",
      // button: {
      //   fontWeight: 800,
      // },
    },
  };

  if (window.whiteLabel === "jamezz") {
    themeObj.palette.primary.main = "#f47840";
  }

  const theme = createMuiTheme(themeObj);

  return (
    <ThemeProvider theme={theme}>
      <IntlProvider locale={locale} messages={messages[locale]} defaultLocale={locale} onError={() => {}}>
        <BrowserRouter>
          <DialogProvider>
            <CssBaseline />
            <App />
          </DialogProvider>
        </BrowserRouter>
      </IntlProvider>
    </ThemeProvider>
  );
}

export default AppWrapper;
